import Axios from "./index";

export const addPaymentMethod = params => {
  return Axios.post(`/user/payment_methods`, params);
};


export const updatePaymentMethod = params => {
  return Axios.put(`/user/payment_methods/card_update`, params);
};
